export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    // Try to handle YYYY-MM or other partials gracefully
    try {
      // If value like '2025-09-01', Date should have worked; fallback to return as-is
      return String(value);
    } catch {
      return String(value);
    }
  }
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}


